<template>
  <div :style="{ height: pageHeight + 'px' }">
    <van-nav-bar
      fixed
      title="账号与安全"
      left-text=""
      right-text=""
      left-arrow
      @click-left="onClickLeft"
    />
    <div class="mybox" :style="{ height: pageHeight+ 'px' }" style="margin-top:46px;">
      <div class="myitem">
        <van-cell title="手机号" is-link  :value="this.phoneNum" to="telhomePage"/>
        <van-cell title="密码设置" is-link  value=""  @click="toforgetPSWPage"/>
      </div>
      <div class="myitem laybox">
        <p @click="layout"> 退出登录</p>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { Tabbar, TabbarItem, Col, Row, NavBar, Cell, CellGroup, Button, Toast } from 'vant'

// import axios from 'axios' // 引入axios进行前后端交互
Vue.use(Tabbar, TabbarItem, Col, Row, NavBar, Cell, CellGroup, Button, Toast)

export default {
  name: 'accountPage',
  components: {
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
    [Col.name]: Col,
    [Row.name]: Row,
    [NavBar.name]: NavBar,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Button.name]: Button,
    [Toast.name]: Toast
  },
  created () {
    this.phoneNum = this.$route.query.phoneNum
    localStorage.setItem('phoneNum', this.phoneNum)
  },
  methods: {
    onClickLeft () {
      this.$router.go(-1)// 返回上一页面
    },
    toforgetPSWPage () {
      this.$router.push({
        path: '/forgetPSWPage', query: { phoneNum: this.phoneNum }
      })
    },
    layout () {
      this.util.post('/logout').then(({ data }) => {
        if (data.code === 200) {
          // localStorage.clear() // 清除全部缓存
          localStorage.removeItem('UserToken')
          localStorage.removeItem('passWord')
          localStorage.removeItem('isLogin')
          localStorage.removeItem('phoneNum')
          // 验证成，跳转首页
          this.$router.replace({
            path: '/login'// 进入登录页
          })
          this.util.toast(data.msg)
        } else {
          return Promise.reject(new Error(data.message || data.msg || '系统错误，请稍后再试。'))
        }
      })
    }

  },
  computed: {},
  data () {
    return {
      phoneNum: '',
      pageHeight: window.innerHeight - 46
    }
  }
}
</script>

<style scoped lang="less">
/deep/.van-nav-bar__content {
  height: 46px;
}
/deep/.van-nav-bar__title {
  font-size: 17px;
  font-weight: bold;
}
/deep/.van-nav-bar .van-icon {
  font-size: 17px;
  color: #A6A6A6;
}

</style>
